import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useReveal } from "@/hooks/useReveal";
import { Mail, Send } from "lucide-react";

export function Newsletter() {
  const head = useReveal();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error("Merci d'accepter de recevoir la newsletter (RGPD)."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, first_name: firstName, consent });
      if (data.status === "already_subscribed") toast.info("Tu es déjà abonné(e) ! 🙌");
      else { toast.success("Abonnement confirmé ! Un email de bienvenue arrive. 🔥"); setDone(true); }
      setEmail(""); setFirstName(""); setConsent(false);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <section data-testid="newsletter-section" className="relative py-20 md:py-24 bg-ink-2">
      <div ref={head.ref} className={`max-w-4xl mx-auto px-4 sm:px-8 text-center ${head.className}`}>
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-mustard/15 mb-5">
          <Mail className="w-6 h-6 text-mustard" />
        </div>
        <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tight">
          Reste dans <span className="text-mustard">la boucle</span>
        </h2>
        <p className="mt-4 text-cream/70 max-w-xl mx-auto">
          Events, stages, ouvertures de cours, battles… reçois toutes les actus de la Factory directement dans ta boîte mail.
          Pas besoin d'être adhérent(e).
        </p>

        {done ? (
          <div data-testid="newsletter-success" className="mt-8 max-w-lg mx-auto glass rounded-2xl p-6">
            <p className="font-display font-bold text-lg">Tu es dans la boucle !</p>
            <p className="mt-2 text-sm text-cream/60">Un email de bienvenue vient de partir. Pense à vérifier tes spams si tu ne le vois pas.</p>
          </div>
        ) : (
        <form onSubmit={submit} data-testid="newsletter-form" className="mt-8 max-w-lg mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              data-testid="newsletter-firstname-input"
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Prénom (optionnel)"
              maxLength={60}
              className="sm:w-44 rounded-full bg-ink border border-white/10 px-5 py-3 text-cream placeholder:text-cream/30 focus:border-mustard focus:outline-none"
            />
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ton@email.com"
              className="flex-1 rounded-full bg-ink border border-white/10 px-5 py-3 text-cream placeholder:text-cream/30 focus:border-mustard focus:outline-none"
            />
            <button
              data-testid="newsletter-submit-btn"
              type="submit"
              disabled={loading}
              className="btn-mustard rounded-full px-6 py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60"
            >
              <Send className="w-4 h-4" /> {loading ? "..." : "Je m'abonne"}
            </button>
          </div>
          <label className="mt-4 flex items-start gap-2 text-left text-xs text-cream/50 max-w-md mx-auto cursor-pointer">
            <input
              data-testid="newsletter-consent"
              type="checkbox"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              className="mt-0.5 accent-[#DD3733]"
            />
            <span>J'accepte de recevoir la newsletter de l'AJDR Factory. Un lien de désabonnement figure dans chaque email (RGPD).</span>
          </label>
        </form>
        )}
      </div>
    </section>
  );
}
